module.exports = __webpack_public_path__ + "img/icon-mail.7274b639.svg";